export type Portal = 'customer' | 'owner' | 'admin' | 'root';

const LABELS: Record<Exclude<Portal, 'root'>, string> = {
  customer: 'menu',
  owner: 'owner',
  admin: 'admin',
};

const OVERRIDES: Record<Exclude<Portal, 'root'>, string | undefined> = {
  customer: import.meta.env.VITE_CUSTOMER_HOST,
  owner: import.meta.env.VITE_OWNER_HOST,
  admin: import.meta.env.VITE_ADMIN_HOST,
};

export function portalForHost(
  hostname: string = window.location.hostname,
): Portal {
  const host = hostname.toLowerCase().split(':')[0] ?? '';

  for (const portal of ['customer', 'owner', 'admin'] as const) {
    const override = OVERRIDES[portal];
    if (override) {
      const target = override.replace(/^https?:\/\//, '').split('/')[0]?.toLowerCase();
      if (target && (host === target || host.endsWith(`.${target}`))) return portal;
    }

    const firstLabel = host.split('.')[0];
    if (firstLabel === LABELS[portal]) return portal;
  }

  return 'root';
}

export function portalUrl(portal: Exclude<Portal, 'root'>): string {
  const { protocol, hostname, port } = window.location;
  const suffix = port ? `:${port}` : '';

  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return '/';

  const override = OVERRIDES[portal];
  if (override) {
    const withProtocol = /^https?:\/\//.test(override) ? override : `${protocol}//${override}`;
    return withProtocol.split('/').slice(0, 3).join('/');
  }

  const labels = hostname.split('.');
  const first = labels[0];
  const isPortalLabel = Object.values(LABELS).includes(first ?? '');
  const base = isPortalLabel ? labels.slice(1).join('.') : hostname;

  return `${protocol}//${LABELS[portal]}.${base}${suffix}`;
}
